import type { FeatureFlag } from "./types";

export const FEATURE_FLAGS = {
	/**
	 * Whether the app is in development mode.
	 *
	 * @since Start
	 * @default false
	 * @until Forever
	 * @owner MaxAltena
	 */
	isDevelopment: {
		key: "development",
		type: "boolean",
		defaultValue: false,
	},
	/**
	 * Whether the core value refine feature is enabled.
	 *
	 * @since ???
	 * @default false
	 * @until ???
	 * @note In the future this should be enabled by default, so this already forces it to always be enabled in development and staging/production is managed through posthog
	 *
	 * @owner IlayHamer
	 */
	canRefineCoreValue: {
		key: "corevalue-refine-enabled",
		type: "boolean",
		defaultValue: false,
	},
	/**
	 * Whether the perfect day menu item is enabled.
	 *
	 * @since ???
	 * @default false
	 * @until ???
	 * @owner Jess
	 */
	canSeePerfectDayMenuItem: {
		key: "perfect-day-menu-item-enabled",
		type: "boolean",
		defaultValue: false,
	},
	/**
	 * Whether the sharing feature is enabled.
	 *
	 * @since ???
	 * @default false
	 * @until ???
	 * @owner RubenFricke
	 */
	canShare: {
		key: "sharing-enabled",
		type: "boolean",
		defaultValue: false,
	},
} as const satisfies Record<string, FeatureFlag>;
